import { Link } from "wouter";
import { getLoginUrl } from "@/lib/auth-redirect";
import { BrandLockup } from "@/components/brand-lockup";

export function MarketingHeader() {
  const loginUrl = getLoginUrl();
  return (
    <header className="glass sticky top-0 z-50 w-full border-b border-white/40">
      <div className="w-full px-6 md:px-8 lg:px-12 xl:px-16 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center">
          <BrandLockup />
        </Link>
        <div className="flex items-center gap-4">
          <Link
            href="/library"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors hidden sm:block"
          >
            Library
          </Link>
          <Link
            href="/contact"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors hidden sm:block"
          >
            Contact
          </Link>
          <a
            href={loginUrl}
            className="bg-foreground text-background px-4 py-2 rounded-full text-sm font-medium hover:bg-foreground/90 transition-all"
          >
            Start free
          </a>
        </div>
      </div>
    </header>
  );
}
